
import Vue from "vue";
import _ from "lodash";
import store from "./store/session";
import commonStore from "./store/common";
import { ServedCode } from "./model/entity/orderSetting";

import "./directives/cursor";
import "./directives/ripple";
import "./directives/click2top";
import { ulid } from "ulid";
import mqtt from "mqtt";
import { isValidHost, shouldSkipConnect } from "./model/mqtt/connectionGuard";
import { buildAcceptCallApi } from "./model/mqtt/acceptCallApi";

import * as animationData from "./assets/order-sending.json";

const acceptCallApi = buildAcceptCallApi(store);

export default Vue.component("App", {
  components: {
    SOHeader: () => import("./components/compositions/SOHeader.vue"),
    SOCart: () => import("./components/compositions/SOCart.vue"),
    SOOrderListButton: () =>
      import("./components/compositions/SOOrderListButton.vue"),
    SOMenu: () => import("./components/compositions/SOMenu.vue"),
    QTranslate: () => import("./components/elements/QTranslate.vue"),
    Lottie: () => import("./components/elements/Lottie.vue")
  },
  data() {
    return {
      lottie: {
        options: {
          loop: true,
          autoplay: true,
          animationData
        }
      },

      appStyle: {},
      scrollY: 0,
      isCartOpen: false,
      isShowThanks: false,
      connection: {
        host: '', // teslint-disable-line
        clientId: ulid(),
        keepalive: 30,
      },
      client: null,

      mode: false,
    };
  },
  created() {
    store.dispatch("load");
    commonStore.dispatch("setMode", "remote");
  },
  mounted() {
    setTimeout(() => {
      this.$router.name != 'remote-checkin' && store.dispatch("checkSession").then((status: string) => {
        this.$router.push("/settle-complete");
      });
    }, 10 * 1000);
    commonStore.dispatch('fetchHoliday');
  },
  computed: {
    isFixScroll() {
      return store.state.isFixScroll;
    },
    isInitializing(): boolean {
      return store.state.isInitializing;
    },
    histories() {
      const histories = _.filter(store.state.histories, history => {
        return (history.is_served === ServedCode.SERVED_READY && history.is_deliver === false);
      });
      return histories;
    },
    isOrdering(): boolean {
      return store.state.isOrdering;
    },
    isLoading(): boolean {
      return store.state.isLoading;
    },
    shop() {
      return store.state.shop;
    },
    wsSignedUrl() {
      return store.state.wsUrl;
    },
    isDone() {
      return store.state.isDone;
    },
    tabeSessionid() {
      return store.state.tableSession.table_session_id;
    }
  },
  methods: {
    handleUpdateTitle(title: string) {
      document.title = title;
    },
    createConnection() {
      const { host, ...options } = this.connection;
      if (!isValidHost(host)) {
        console.log("createConnection: invalid host, skip", host);
        return;
      }
      if (shouldSkipConnect(this.client, this._connecting)) {
        console.log("createConnection: already connected/connecting, skip");
        return;
      }
      if (this.client) {
        this.client.removeAllListeners();
        this.client.end(true);
      }
      this._connecting = true;
      try {
        this.client = mqtt.connect(host, { ...options, reconnectPeriod: 0 });
      } catch (error) {
        this._connecting = false;
        console.log("mqtt.connect error", error);
        return;
      }
      this.client.on("connect", () => {
        this._connecting = false;
        console.log("Connection succeeded!");
        this.doSubscribe();
      });
      this.client.on("error", (error) => {
        this._connecting = false;
        console.log("Connection failed", error);
      });
      this.client.on("message", (topic, message) => {
        this.handleReciverMessage(topic, message);
      });
      this.client.on("close", () => {
        this._connecting = false;
        if (this._intentionalClose) {
          this._intentionalClose = false;
          return;
        }
        // 署名付きURLが失効している可能性があるため、再接続前に取得し直す
        setTimeout(() => {
          store.dispatch("getWsUrl");
        }, 5000);
      });
    },
    doSubscribe() {
      const { qos, topic } = {
        topic: `shop/${this.shop.id}`,
        qos: 0,
      };

      this.client.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        console.log("Subscribe to topics res", res);
      });
    },
    handleReciverMessage(topic, message) {
      let payload = JSON.parse(message);
      if (
        acceptCallApi[payload.type] &&
        acceptCallApi[payload.type].page.includes(this.page)
      ) {
        acceptCallApi[payload.type].callApi(this, payload);
      } else if (
        acceptCallApi[payload.type] &&
        acceptCallApi[payload.type].page.length === 0 // case alway call api
      ) {
        acceptCallApi[payload.type].callApi(this, payload);
      }
    },
    handleClickCloseModal: function () {
      this.mode = false;
    },
  },
  watch: {
    histories() {
      if (this.shop.is_select_receive && this.histories.length > 0) {
        this.mode = true;
      } else {
        this.mode = false;
      }
    },
    isOrdering() {
      if (this.isOrdering === false && store.state.cart.orders.length === 0) {
        this.isShowThanks = true;
        setTimeout(() => {
          this.isShowThanks = false;
        }, 5000);

        // ODR-1051
        this.$router.push('/category');
      }
    },
    isFixScroll() {
      if (this.isFixScroll) {
        this.scrollY = window.scrollY;
        this.appStyle = {
          top: `-${scrollY}px`,
          position: "fixed"
        };
      } else {
        this.appStyle = {};
        setTimeout(() => {
          window.scrollTo({
            left: 0,
            top: this.scrollY,
            behavior: "smooth"
          });
        }, 100);
      }
    },
    shop: function(newVal, oldVal) {
      if (newVal && newVal.id) {
        if (!(this.client && this.client.connected)) {
          store.dispatch('getWsUrl');
        }
      } else if (!newVal) {
        !['error', 'remote-settle-complete'].includes(this.$router.currentRouter.name)
        && this.$router.push('error');
      }
    },
    wsSignedUrl: function(newVal, oldVal) {
      console.log("Watch :" + newVal);
      this.connection.host = newVal;
      this.createConnection();
    },
    isDone: function(newVal) {
      if (newVal && this.client) {
        console.log('end connect wss');
        this.client.end();
      }
    }
  }
});
